import { render, staticRenderFns } from "./TestimonialTrainer.vue?vue&type=template&id=da87a932&scoped=true&"
import script from "./TestimonialTrainer.vue?vue&type=script&lang=js&"
export * from "./TestimonialTrainer.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialTrainer.vue?vue&type=style&index=0&id=da87a932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da87a932",
  null
  
)

export default component.exports